import { createRoot } from 'react-dom/client'
import { AppError } from '@cetused/shared'
import { App } from './App'
import { bootSequence } from './boot'
import { QueryProvider } from './api/providers/QueryProvider'

async function main() {
  try {
    await bootSequence()
    const root = document.getElementById('root')
    if (!root) throw AppError.internal('Missing #root mount point')
    createRoot(root).render(
      <QueryProvider>
        <App />
      </QueryProvider>,
    )
  } catch (err) {
    // Fail closed, loudly: the failure must reach the user even when #root is
    // absent — a missing mount point must not throw here and bury the real
    // boot error under a TypeError.
    console.error('[CetusEd] Boot failed — application cannot start', err)
    const mount = document.getElementById('root') ?? document.body
    mount.textContent =
      'CetusEd failed to start. Please refresh or contact your district administrator.'
  }
}

main()
